import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("input field", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-input-field></ux-input-field>`);
        const el = await page.find("ux-input-field");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-input-field label="test"></ux-input-field>`);
        const el = await page.find("ux-input-field");
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot when error is set", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-input-field label="test" error error-msg="Error Message"></ux-input-field>`);
        const el = await page.find("ux-input-field");
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with some props", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-input-field label="Label" type="text" id="input" name="input" placeholder="Placeholder"></ux-input-field>`
        );
        const el = await page.find("ux-input-field");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot if slot content is present", async () => {
        const page = await newE2EPage();
        const slotContent = '<span class="ux-label__error-message">Test <a href="#">Link</a> Lorem</span>';
        await page.setContent(
            `<ux-input-field
            error
            label="Label"
            placeholder="Placeholder"
            required
        >
            ` +
                slotContent +
                `
        </ux-input-field>`
        );
        const el = await page.find("ux-input-field");
        expect(el).toMatchSnapshot();
    });

    it("should emit the correct events", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `
            <div>
                <ux-input-field type="text" input-id="test-id" label="test" name="test-input"></ux-input-field>
                <button type="button" class="element"></button>
            </div>
            `
        );
        await page.waitForChanges();
        const uxInputField = await page.find("ux-input-field");
        const nativeInputFiled = await uxInputField.findAll("input");
        const siblingElement = await page.find(".element");
        expect(nativeInputFiled.length).toBe(1);
        const uxInputChangeEvent = await page.spyOnEvent("uxInputChange");
        const uxInputEvent = await page.spyOnEvent("uxInput");
        const uxChangeEvent = await page.spyOnEvent("uxChange");
        const uxFocusEvent = await page.spyOnEvent("uxFocus");
        const uxBlurEvent = await page.spyOnEvent("uxBlur");
        const uxInvalidEvent = await page.spyOnEvent("uxInvalid");
        await page.waitForChanges();
        expect(uxInputField).toHaveClass("hydrated");
        await nativeInputFiled[0].press("A");
        expect(uxInputChangeEvent).toHaveReceivedEventDetail({
            currentValue: "A",
            inputName: "test-input",
            inputId: "test-id"
        });
        expect(uxFocusEvent).toHaveReceivedEvent();
        expect(uxInputEvent).toHaveReceivedEvent();
        expect(uxChangeEvent).not.toHaveReceivedEvent();
        expect(uxBlurEvent).not.toHaveReceivedEvent();
        expect(uxInvalidEvent).not.toHaveReceivedEvent();
        await siblingElement.click();
        await page.waitForChanges();
        expect(uxChangeEvent).toHaveReceivedEvent();
        expect(uxBlurEvent).toHaveReceivedEvent();
        expect(uxInvalidEvent).not.toHaveReceivedEvent();
    });

    it("should emit the correct events when clearable", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `
            <div>
                <ux-input-field type="text" input-id="test-id-2" label="test-2" name="test-input-2" clearable></ux-input-field>
                <button type="button" class="element"></button>
            </div>
            `
        );
        await page.waitForChanges();
        const uxInputField = await page.find("ux-input-field");
        const nativeInputFiled = await uxInputField.findAll("input");
        expect(nativeInputFiled.length).toBe(1);
        const uxInputChangeEvent = await page.spyOnEvent("uxInputChange");
        const uxInputEvent = await page.spyOnEvent("uxInput");
        const uxChangeEvent = await page.spyOnEvent("uxChange");
        const uxFocusEvent = await page.spyOnEvent("uxFocus");
        const uxInvalidEvent = await page.spyOnEvent("uxInvalid");
        await page.waitForChanges();
        expect(uxInputField).toHaveClass("hydrated");
        await nativeInputFiled[0].press("B");
        await page.waitForChanges();
        const clearButton = await page.find(".ux-input-field__clear");
        expect(uxInputEvent).toHaveReceivedEvent();
        expect(uxFocusEvent).toHaveReceivedEvent();
        expect(uxInputChangeEvent).toHaveReceivedEventDetail({
            currentValue: "B",
            inputName: "test-input-2",
            inputId: "test-id-2"
        });
        await clearButton.click();
        await page.waitForChanges();
        expect(uxChangeEvent).toHaveReceivedEvent();
        expect(uxInvalidEvent).not.toHaveReceivedEvent();
    });

    it("should match to snapshot with copy to clipboard", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-input-field label="test" type="text" copy-to-clipboard></ux-input-field>`);
        const el = await page.find("ux-input-field");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-input-field label="Label" type="text" id="input" name="input" placeholder="Placeholder"></ux-input-field>`
        );
    });
});
